// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.border-transparent[data-v-9578fb06] {\n    border-left: 5px solid transparent !important;\n}\n.border[data-v-9578fb06] {\n    border-left: 5px solid#1B3054 !important;\n}\n.drawer-logo[data-v-9578fb06] {\n    border-bottom: 1px solid #edeef1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
